module.exports = __webpack_public_path__ + "img/teams.661c3886.svg";